export default __webpack_public_path__ + "static/media/alterRealm.efe63788.png";